import { CognitoJwtVerifier } from 'aws-jwt-verify';
import {
  COGNITO_INSPECTOR_CLIENT_ID,
  COGNITO_INSPECTOR_USER_POOL_ID,
  COGNITO_SIC_CLIENT_ID,
  COGNITO_SIC_USER_POOL_ID,
} from '../../../shared/api/config';

/**
 * Verifier singleton.  Se crea una sola vez,
 * por lo que mantiene cacheado el JWKS.
 */
export const cognitoVerifier = CognitoJwtVerifier.create({
  userPoolId: COGNITO_INSPECTOR_USER_POOL_ID,
  tokenUse: 'id',
  clientId: [COGNITO_INSPECTOR_CLIENT_ID],
});

export const cognitoVerifierSic = CognitoJwtVerifier.create({
  userPoolId: COGNITO_SIC_USER_POOL_ID,
  tokenUse: 'access',
  clientId: [COGNITO_SIC_CLIENT_ID],
});
